// bao migrate skip
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import BaoMenuItem from "interfaces/bao/bao-menu-item";
import ConfigurationItemAuditDialog from "./../../factories/configuration-item-audit-dialog";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import * as moment from "moment";
import * as ko from "knockout";
import BaoDialog from "./../../factories/bao-dialog";
import { IShiftReportTab } from "../../interfaces/ishift-report-tab";

export interface ReportShiftStaffModel {
    ReportShiftStaffId: KnockoutObservable<string>;
    ReportId: KnockoutObservable<string>;
    PersonId: KnockoutObservable<string>;
    PersonName1: KnockoutObservable<string>;
    PersonName2: KnockoutObservable<string>;
    PersonFullName: KnockoutObservable<string>;
    WorkplaceId: KnockoutObservable<string>;
    WorkplaceName: KnockoutObservable<string>;
    Remark: KnockoutObservable<string>;
    PresentFromHtml: KnockoutObservable<string>;
    PresentToHtml: KnockoutObservable<string>;
    DurationInMinutes: KnockoutObservable<number>;
    IsNew: KnockoutObservable<boolean>;
    // MASKED FOR INPUT FIELD read & write!
    DurationFormatted?: KnockoutComputed<string>;
}
class ShiftReportShiftStaff implements IShiftReportTab {
    ToolbarName: string = null;
    ToolbarButtons = ko.observableArray<Interfaces.Bao.BaoMenuItem>([]);
    Models: KnockoutObservableArray<ReportShiftStaffModel> = ko.observableArray([]);
    ShiftGroupName: KnockoutObservable<string> = ko.observable();
    ShiftGroupId: KnockoutObservable<string> = ko.observable();
    EditPermission: KnockoutObservable<boolean> = ko.observable();
    AvailableEmployees: KnockoutObservableArray<any> = ko.observableArray([]);
    AvailableEmployeesString: KnockoutObservable<string> = ko.observable();
    AbsentEmployees: KnockoutObservableArray<any> = ko.observableArray([]);
    Permissions: KnockoutObservableArray<any> = ko.observableArray([]);
    AbsentEmployeesString: KnockoutComputed<string> = ko.pureComputed(() => {
        return this.AbsentEmployees().map(a => a.FullName).join(', ');
    });
    ShowReportShiftGroupName = ko.observable(false);
    ModelsLoadFromDefault = false;
    DisplayMessage: KnockoutObservable<boolean> = ko.observable(false);

    TabPage: TabPage;
    ShiftReport: {
        ReportId: KnockoutObservable<string>;
        IsClosed: KnockoutObservable<boolean>;
        IsOriginal: KnockoutObservable<boolean>;
        CurrentRevision: KnockoutObservable<string>;
        toggleOriginal: (state: boolean) => void;
        toggleRevision: (state: boolean) => void;
        ShiftStartTimeHtml: KnockoutObservable<string>;
        ShiftEndTimeHtml: KnockoutObservable<string>;
        ShiftbookId: KnockoutObservable<string>;
    } = null;
    constructor(tabPage: TabPage, parent: any) {
        this.TabPage = tabPage;
        this.ShiftReport = parent;
        this.Subscribe(this.ToolbarButtons, () => {
            this.ToggleToolbarButtons();
            this.SetVisibilityButtons();
        });
        this.Permissions.subscribe(_ => {
            this.SetVisibilityView();
            this.SetVisibilityButtons();
        });
        this.AvailableEmployees.subscribe(() => {
            this.setAvailableEmployeesString();
        });
    }
    private _subscriptions: KnockoutSubscription[] = [];
    Subscribe<T>(obs: KnockoutObservable<T>, fn: (newValue?: T) => void) {
        this._subscriptions.push(obs.subscribe(fn));
    }
    ToolbarClick = (button: Interfaces.Bao.BaoMenuItem) => {
        var key = ko.unwrap(button.ActionKey);
        switch (key) {
            case "ShiftReportTabShiftStaffSave":
                this.Save();
                break;
            case "ShiftReportTabShiftStaffRefresh":
                this.Refresh();
                break;
            case "ShiftReportTabShiftStaffAuditTrail":
                this.ShowAuditTrail();
                break;
            default:
                this.CustomToolbarClick(button);
                break;
        }
    };
    /**
     * Check everything and calls on success this.SaveEntities
     */
    Save() {
        return $.when(this.CompleteCheck())
            .then((res: boolean) => {
                if (res === false) {
                    return;
                }
                return this.SaveEntities();
            })
            .then(() => {
                this.LoadData();
            });
    }
    ShowAuditTrail() {
        let getCollectionUrl = "ShiftReportTabShiftStaff/GetAuditTrail";
        let filterArea = null;
        let reportId = ko.unwrap(this.ShiftReport.ReportId);
        let auditDialog = new ConfigurationItemAuditDialog(reportId, ko.unwrap(this.TabPage.Title), this.TabPage, getCollectionUrl);
        auditDialog.Open();
    }
    /**
     * Loads and sets the data - without checkign anything (for checks see this.refresh)
     */
    LoadData() {
        this.TabPage.IsLoading(true);
        return this.getDataFromServer(this.ShiftReport.ReportId())
            .then(serverResult => {
                let newArr = [];
                for (let item of serverResult.Models) {
                    if (item.IsNew === true && item.PresentFromHtml === "") {
                        item.PresentFromHtml = this.ShiftReport.ShiftStartTimeHtml();
                        item.PresentToHtml = this.ShiftReport.ShiftEndTimeHtml();
                        item.DurationInMinutes = moment.duration(moment(this.ShiftReport.ShiftEndTimeHtml(), Bao.Utils.DateTimeFormat)
                            .diff(moment(this.ShiftReport.ShiftStartTimeHtml(), Bao.Utils.DateTimeFormat))).asMinutes();
                    }
                    // we need to get properties as observables to get working computed "DurationFormatted"
                    let tmpItemObservables = {};
                    ko.map.fromJS(item, tmpItemObservables, this.TabPage.DirtyFlag);
                    this.AddDurationFormatted(<any>tmpItemObservables);
                    this.ShiftGroupId(serverResult.ShiftGroupId);
                    this.ShiftGroupName(serverResult.ShiftGroupName);
                    this.AvailableEmployees(serverResult.AvailableEmployees);
                    this.AbsentEmployees(serverResult.AbsentEmployees);
                    this.ShowReportShiftGroupName(serverResult.ShowReportShiftGroupName);
                    newArr.push(tmpItemObservables);
                }
                this.Models.removeAll();
                this.Models(newArr);
                if (serverResult.Models && serverResult.Models[0] !== undefined) {
                    if (this.Models() && this.Models().length > 0) {
                        this.ModelsLoadFromDefault = this.Models()[0].IsNew();
                    }
                }
                this.Models().forEach(model => this.initModelSubscribes(model));
                this.TabPage.IsLoading(false);
                this.TabPage.DirtyFlag.reset();
            });
    }
    private getDataFromServer(reportid: string) {
        return Bao.post("ShiftReportTabShiftStaff/GetModels", JSON.stringify({ reportId: reportid }));
    }
    private getSaveParams() {
        let ret = {
            models: ko.map.toJS(this.Models),
            reportId: this.ShiftReport.ReportId()
        };
        return ret;
    }
    /**
     * Saves the models to the server - without checking anyothing (for check see this.Save)
     */
    SaveEntities() {
        this.ModelsLoadFromDefault = false;
        return Bao.post("ShiftReportTabShiftStaff/Save", JSON.stringify(this.getSaveParams()));
    }
    SaveAllowed = ko.pureComputed(() => {
        let saveAllowed = false;
        this.ToolbarButtons().forEach((btn) => {
            if (ko.unwrap(btn.ActionKey) === "ShiftReportTabShiftStaffSave") {
                saveAllowed = true;
            }
        });
        return saveAllowed;
    });
    /**
     * Checks unsaved changes, save is allowed and wanted, refresh the page or cancel action
     */
    Refresh() {
        if (this.TabPage.DirtyFlag() == true && this.SaveAllowed()) {
            var questionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSaveCheck"), "question");
            this.Subscribe(questionDialog.DialogResult, (result) => {
                // true === save
                if (result == true) {
                    $.when(this.CompleteCheck())
                        .then((result) => {
                            if (result == true) {
                                this.Save()
                                    .then(() => {
                                        this.LoadData();
                                    });
                            }
                        });
                }
                // false === dont save
                else if (result === false) {
                    this.LoadData();
                }
                // cancel is unhandled (dialog closed, nothing to do )
            });
        }
        // if save is NOT allowed, dont ask & discard changes and refresh
        else {
            this.LoadData();
        }
    }
    init() {
        this.TabPage.IsLoading(true);
        return this.LoadPermissions()
            .then(_ => this.LoadData())
            .always(_ => this.TabPage.IsLoading(false));
    }
    loaded() {
        this.TabPage.IsLoading(false);
    }
    canClose(): JQueryPromise<boolean> {
        let canClose: boolean = !(ko.unwrap(this.SaveAllowed) && this.TabPage.DirtyFlag());
        return $.Deferred<boolean>().resolve(canClose).promise();
    }
    CompleteCheck(): JQueryPromise<boolean> {
        //if (irgendebs_is_invalid) {
        //    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        //    return false;
        //}
        return $.Deferred<boolean>().resolve(true).promise();
    }
    CustomToolbarClick(button) {
    }
    ///**
    // * will be invoked by ShiftReport.ts when report is closing
    // */
    //CloseReport() {
    //}
    ToggleToolbarButtons() {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            var key = ko.unwrap(button.ActionKey);
            var enabled = <KnockoutObservable<boolean>>(button.Enabled);
        });
    }
    removeRow(entry: ReportShiftStaffModel) {
        this.Models.remove(entry);
        this.TabPage.DirtyFlag(true);
    }
    addRow() {
        let row: ReportShiftStaffModel = {
            PersonId: ko.observable(null),
            PersonName1: ko.observable(null),
            PersonName2: ko.observable(null),
            PersonFullName: ko.observable(null),
            PresentFromHtml: ko.observable(this.ShiftReport.ShiftStartTimeHtml()),
            PresentToHtml: ko.observable(this.ShiftReport.ShiftEndTimeHtml()),
            //workplaceId i guess
            WorkplaceId: ko.observable(null),
            WorkplaceName: ko.observable(null),
            Remark: ko.observable(null),
            ReportId: ko.observable(this.ShiftReport.ReportId()),
            ReportShiftStaffId: ko.observable(null),
            // HACK
            DurationInMinutes: ko.observable(moment(this.ShiftReport.ShiftEndTimeHtml(), Bao.Utils.DateTimeFormat)
                .diff(moment(this.ShiftReport.ShiftStartTimeHtml(), Bao.Utils.DateTimeFormat))
                / 1000 / 60),
            IsNew: ko.observable(true)
        };
        this.AddDurationFormatted(row);
        this.Models.push(row);
        this.TabPage.DirtyFlag(true);
    }
    private AddDurationFormatted(item: ReportShiftStaffModel) {
        item.DurationFormatted = ko.computed({
            read: function () {
                let mins = (isNaN(this.DurationInMinutes()) ? 0 : this.DurationInMinutes());
                return `${Math.floor(mins / 60)}:${(mins % 60) < 10 ? "0" : ""}${(mins % 60)}`;
            }.bind(item),
            write: function (val) {
                let found = val.match(/^((\d*):)?(\d*)$/);
                if (found === null) {
                    this.DurationInMinutes(0);
                    return;
                }
                let hours = Number(found[2] ?? 0);
                let minutes = Number(found[3] ?? 0);
                this.DurationInMinutes(hours * 60 + minutes);
            }.bind(item),
            owner: item
        });
    }
    /**
     * parses 90 to YYYYMMDD0130ss
     * @param datestring
     */
    private MinutesToYYYYMMDDHHmmss(minutes: number) {
        return moment("20000101000000", Bao.Utils.DateTimeFormat).add(minutes, "m").format(Bao.Utils.DateTimeFormat);
    }
    /**
     * parses YYYYMMDD0130ss to 90
     * @param datestring
     */
    private YYYYMMDDHHmmssToMinutes(datestring: string) {
        let valAsMoment = moment(datestring, Bao.Utils.DateTimeFormat);
        return (valAsMoment.minutes() + valAsMoment.hours() * 60);
    }
    dispose() {
        for (var y = 0; y < this._subscriptions.length; y++) {
            this._subscriptions[y].dispose();
        }
        this._subscriptions = null;
    }
    ;
    BindingToolbar: Bindings.baoToolbar2 = {
        buttons: this.ToolbarButtons,
        click: this.ToolbarClick,
        toolbarName: this.ToolbarName,
        formName: "ShiftReportTabShiftStaff",
        applicationId: "e08aa793-c9ad-4c68-bf21-06014ea951a3"
    };

    initModelSubscribes = (model: ReportShiftStaffModel) => {
        this.setAvailableEmployeesString();
        if (model.PersonId !== null) {
            model.PersonId.subscribe(() => {
                this.setAvailableEmployeesString();
            });
        }
    }

    private setAvailableEmployeesString() {
        var availableEmployeesToShow = [];
        this.AvailableEmployees().forEach(availableEmployee => {
            var found = false;
            for (var model of this.Models()) {


                if (model.PersonId() === availableEmployee.PersonId) {
                    found = true;

                    break;
                }
            }
            if (!found) {

                availableEmployeesToShow.push(availableEmployee.FullName);

            }
        });

        this.AvailableEmployeesString(availableEmployeesToShow.join(", "));
    }

    private LoadPermissions() {
        return Bao.post("RoleShiftbookTab/GetPermissions", JSON.stringify({ shiftbookId: this.ShiftReport.ShiftbookId(), shiftbookTabId: this.TabPage.ObjectId() }))
            .then((result) => this.Permissions(result.Permissions));
    }

    private SetVisibilityButtons() {
        this.ToolbarButtons().forEach((btn) => {
            const actionKey = ko.unwrap(btn.ActionKey);
            let permission = this.Permissions()[actionKey];
            if (permission === null || permission === undefined)
                permission = false;
            btn.Visible = permission;
        });
    }

    private SetVisibilityView() {
        const readPermission = this.Permissions()["ShiftReportTabShiftStaffRefresh"];
        if (!readPermission) {
            this.DisplayMessage(true);
        }
    }
}
export default ShiftReportShiftStaff;